// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.imprint {
  padding: 20px 40px;
  box-sizing: border-box;
  max-height: 90vh;
  overflow-y: auto;
}
div.imprint h2 {
  color: #444;
}
div.imprint a {
  color: #444;
}
div.imprint a:hover {
  color: rgb(222, 41, 34);
}
div.imprint hr {
  border: 1px solid rgba(0, 0, 0, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/app/imprint/imprint.component.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAEA;EACI,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;AADJ;AAGI;EACI,WCTI;ADQZ;AAII;EACI,WCbI;ADWZ;AAIQ;EACI,uBCRH;ADMT;AAMI;EACI,oCAAA;AAJR","sourcesContent":["@use 'colors' as *;\n\ndiv.imprint {\n    padding: 20px 40px;\n    box-sizing: border-box;\n    max-height: 90vh;\n    overflow-y: auto;\n\n    h2 {\n        color: $text-dark;\n    }\n\n    a {\n        color: $text-dark;\n\n        &:hover {\n            color: $cv-red;\n        }\n    }\n\n    hr {\n        border: 1px solid rgba(0,0,0,0.1);\n    }\n}\n","$text-dark: #444;\n\n$dark-gray: rgba(0,0,0,0.6);\n$light-gray: rgba(0,0,0,0.10);\n\n$dates-background: rgba(0,0,0,0.05);\n\n// cornelsen colors\n$cv-red: rgb(222,41,34);\n$cv-grass-dark: rgb(107,171,45);\n$cv-grass-medium: rgb(177,198,16);\n$cv-grass-light: rgb(220,235,205);\n$cv-sky-dark: rgb(0,148,170);\n$cv-sky-medium: rgb(109,186,210);\n$cv-sky-light: rgb(210,235,235);\n$cv-sand-dark: rgb(175,157,140);\n$cv-sand-medium: rgb(212,202,189);\n$cv-sand-light: rgb(240,230,225);\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
